import { ComponentProps } from "react";
import cx from "classnames";

export const BackgroundBlob = () => {
  return (
    <div className="hidden dsk:flex absolute size-full inset-0 flex-col items-end justify-center overflow-clip pointer-events-none">
      <Blob className="h-full w-2/3 -translate-y-1/2 translate-x-1/2" />
      <Blob className="size-full translate-y-[-35%] translate-x-[45%]" />
    </div>
  );
};

const Blob = (props: ComponentProps<"div">) => (
  <div
    {...props}
    className={cx(
      "absolute top-1/2 right-0 bg-brand-red bg-gradient-to-t from-palette-current-true/30 via-palette-current-true/0 to-palette-current-true/0 bg-transparent animate-blobPulse",
      props.className
    )}
    style={{
      backgroundImage: "radial-gradient(ellipse, var(--tw-gradient-stops))",
      ...props.style,
    }}
  />
);
